var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableBalanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30,
    fill: "#F2F4FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 31C13.5 33.1668 13.9268 35.3124 14.756 37.3143C15.5852 39.3161 16.8006 41.1351 18.3327 42.6673C19.8649 44.1994 21.6839 45.4148 23.6857 46.244C25.6876 47.0732 27.8332 47.5 30 47.5C32.1668 47.5 34.3124 47.0732 36.3143 46.244C38.3161 45.4148 40.1351 44.1994 41.6673 42.6673C43.1994 41.1351 44.4148 39.3161 45.244 37.3143C46.0732 35.3124 46.5 33.1668 46.5 31C46.5 28.8332 46.0732 26.6876 45.244 24.6857C44.4148 22.6839 43.1994 20.8649 41.6673 19.3327C40.1351 17.8006 38.3161 16.5852 36.3143 15.756C34.3124 14.9268 32.1668 14.5 30 14.5C27.8332 14.5 25.6876 14.9268 23.6857 15.756C21.6839 16.5852 19.8649 17.8006 18.3327 19.3327C16.8006 20.8649 15.5852 22.6839 14.756 24.6857C13.9268 26.6876 13.5 28.8332 13.5 31Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2333 26.0013C33.9918 25.5301 33.6409 25.1416 33.2181 24.8774C32.7954 24.6133 32.3167 24.4834 31.8333 24.5017H29.1667C28.4594 24.5017 27.7811 24.8177 27.281 25.3801C26.781 25.9426 26.5 26.7054 26.5 27.5008C26.5 28.2963 26.781 29.0591 27.281 29.6216C27.7811 30.184 28.4594 30.5 29.1667 30.5H31.8333C32.5406 30.5 33.2189 30.816 33.719 31.3784C34.219 31.9409 34.5 32.7037 34.5 33.4992C34.5 34.2946 34.219 35.0574 33.719 35.6199C33.2189 36.1823 32.5406 36.4983 31.8333 36.4983H29.1667C28.6833 36.5166 28.2046 36.3867 27.7819 36.1226C27.3591 35.8584 27.0082 35.4699 26.7667 34.9987",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 22.5L30.5 38.5",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableBalanceIcon);
export default __webpack_public_path__ + "static/media/available-balance-icon.530177cddad56907531b95efd441a589.svg";
export { ForwardRef as ReactComponent };